import tinycolor from "tinycolor2";
import { getColors } from "../../../jss_setup/colors";

export const hotelSearchStrip = {
  SearchStripDefault: {
    background: "#B9CED8",
  },
};

export const hotelFiltersBar = {
  FiltersBar: {
    background: "#E8EFF2",
  },
  newSearchBtnStyles: {
    ButtonDefault: {
      borderRadius: "0px",
    },
  },
};

export const hotelSearchStripDest = {
  valueContr: {
    borderRadius: "0px",
    border: "none",
  },
};

export const hotelSearchStripDates = {
  valueContr: {
    borderRadius: "0px",
    border: "none",
  },
};

export const hotelSearchStripPax = {
  valueContr: {
    borderRadius: "0px",
    border: "none",
  },
};

export const hotelBottomContainer = {
  buttonStylesHtlBtmContr: {
    ButtonDefault: {
      borderRadius: "0px",
      background: getColors().secondary_color,
      borderColor: getColors().secondary_color,
    },
  },
};

export const hotelBottomContainerMobileView = {
  buttonStylesHtlBtmContr: {
    ButtonDefault: {
      borderRadius: "0px",
      background: getColors().secondary_color,
      borderColor: getColors().secondary_color,
    },
  },
};

const htlStyles = {
  hotel: { borderRadius: "0px" },
  img: { borderRadius: "0px" },
  RatingPanel: {
    iconFilled: { color: getColors().secondary_color },
  },
};
export const hotelStyles = { ...htlStyles };
export const landingPageHotelStyles = { ...htlStyles };

export const ShowMoreProductsBtn = {
  ButtonDefault: { borderRadius: "0px" },
};

export const HotelMetaControlBtns = {
  ButtonDefault: { borderRadius: "0px" },
};

export const HotelMeta = {
  gradientBackground: {
    background: `linear-gradient(180deg, ${tinycolor(
      getColors().secondary_color
    )
      .lighten(45)
      .toRgbString()} 0%, #FFFFFF 100%)`,
  },
};

export const RoomGroup = {
  RoomGroup: {
    borderRadius: "0px",
    border: `1px solid #E8E8ED`,
  },
  header: {
    borderRadius: "0px",
    background: "#E8E8ED",
    color: "#333132",
  },
};

export const roomGroupPrice = {
  columnTitle: { background: "#FFF5E5" },
  priceComponent: {
    fontSize: "x-large",
  },
};

export const SelectRoomBtn = { selectBtn: { borderRadius: "0px" } };
